import { ListItem, MultiButton, Snackbar, TableSelectionEvent, Toast } from "@mcleod/components";
import { AutogenLayoutManualOpenItemProcessing } from "./autogen/AutogenLayoutManualOpenItemProcessing";
import { CompanySettings, CurrencySettings, ModelRow, StringUtil } from "@mcleod/core";
import { ManualOpenItemProcessingAction, ManualOpenItemProcessingStepper } from "./ManualOpenItemProcessingStepper";
import { ProcessLogViewer } from "@mcleod/general";

export class ManualOpenItemProcessing extends AutogenLayoutManualOpenItemProcessing {
    private multiButtonPrintAndPost: MultiButton;

    override onLoad() {
        const currencySettings = CurrencySettings.getSingleton();
        this.textboxCurrencyType.visible = currencySettings.multiCurrencyEnabled();

        this.initializePrintAndPostButton();
        this.processLogButton.visible = CompanySettings.getSingleton().isProcessLogEnabled();
    }

    tableManualOpenItemsOnSelect(event: TableSelectionEvent) {
        const selectedRowCount = event.table.selectedRowCount;
        this.multiButtonPrintAndPost.enabled = selectedRowCount > 0;
        this.multiButtonPrintAndPost.showSeparator = true;
    }

    initializePrintAndPostButton() {
        this.multiButtonPrintAndPost = new MultiButton({
            dropdownItems: this.createMultiButtonItems(),
            color: "primary.reverse",
            backgroundColor: "primary",
            enabled: false,
            showSeparator: true
        });

        this.multiButtonPrintAndPost.primaryButton.setProps({
            themeKey: "editRowDecorator.primaryButton",
            id: "multiButtonPrintAndPost",
            caption: "Print & Post",
            enabled: false,
            onClick: () => {
                ManualOpenItemProcessingStepper.showAsSlideout({
                    action: ManualOpenItemProcessingAction.PRINT_AND_POST,
                    selectedRows: this.tableManualOpenItems.selectedRows.map(row => row.data as ModelRow),
                    doAfterSlideOut: this.getCommonDoAfterSlideOut()
                });
            }
        });

        this.tableManualOpenItems.addRightTool(this.multiButtonPrintAndPost);
    }

    createMultiButtonItems(): ListItem[] {
        return [
            new ListItem({
                text: "Print Manual Open Items",
                onClick: () => {
                    ManualOpenItemProcessingStepper.showAsSlideout({
                        action: ManualOpenItemProcessingAction.PRINT_ONLY,
                        selectedRows: this.tableManualOpenItems.selectedRows.map(row => row.data as ModelRow)
                        // No doAfterSlideOut needed for print-only action. Just close as if cancelled.
                    });
                }
            }),
            new ListItem({
                text: "Post Manual Open Items",
                onClick: () => {
                    ManualOpenItemProcessingStepper.showAsSlideout({
                        action: ManualOpenItemProcessingAction.POST_ONLY,
                        selectedRows: this.tableManualOpenItems.selectedRows.map(row => row.data as ModelRow),
                        doAfterSlideOut: this.getCommonDoAfterSlideOut()
                    });
                }
            })
        ];
    }

    private getCommonDoAfterSlideOut() {
        // postingAttempted indicates that the process was not cancelled before posting. It will be true even no records were posted due to exceptions.
        return (postingAttempted: boolean, postedCount: number) => {
            if (postedCount > 0) {
                // Refresh the displayed results to remove posted records
                if (this.mainDataSource.lastSearch != null) {
                    this.mainDataSource.search({ ...this.mainDataSource.lastSearch.data });
                }
                Toast.showSuccessToast(`${StringUtil.pluralString(postedCount, "open item", "open items")} posted successfully.`);
            } else if (postingAttempted && postedCount === 0) {
                Snackbar.showWarningSnackbar("No open items were posted.");
            }
        }
    }

    processLogButtonOnClick() {
        ProcessLogViewer.showInSlideoutDecorator("Manual Open Items Posting");
    }
}
